module.exports = __webpack_public_path__ + "assets/img/22_273.bef11c9f.jpg";